class RouteCityModel {
    sno?: number;
    count?: number;
    routeCityId?: number;
    name?: string;
    displayOrder?: string;
}
export default RouteCityModel;